module.exports = __webpack_public_path__ + "media/images/pages/img_shopping_01-921afa052ece6895ce8fb0bb58a1c7ec.jpg";